// Bumped automatically by .githooks/pre-commit on every commit.
export const VERSION = "1.43";
